import { Municipio } from './municipio.model';
import { Regiao } from './regiao.model';

export class EnderecoFabrilVO {

  id: number;
  idComposicaoRda: number;
  cep: number;
  logradouro: string;
  bairro: string;
  complemento: string;
  numero: string;
  municipio: Municipio;
  regiao: Regiao;

  constructor(init?: Partial<EnderecoFabrilVO>) {
    Object.assign(this, init);
  }
}
